<template>
  <div class="list-view">
    <h4>Scheduling conditions</h4>
    <div class="container-fluid">
      <div class="row selector-row">
        <div class="col-md-6">
          <p>Invitees can’t schedule within..</p>
          <div class="dropdown-listview">
            <div class="dropdown-target" @click="timeDropdown = !timeDropdown">
              <span> {{ timeLimit }}</span>
              <span>
                <svg
                  fill="none"
                  height="24"
                  viewBox="0 0 24 24"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.277 14.7522L8.45062 10.5007C8.27687 10.3076 8.41388 10 8.67361 10H16.3264C16.5861 10 16.7231 10.3076 16.5494 10.5007L12.723 14.7522C12.6038 14.8846 12.3962 14.8846 12.277 14.7522Z"
                    fill="#B3C2CB"
                  />
                </svg>
              </span>
            </div>
            <transition name="fade">
              <div class="dropdown-list" v-if="timeDropdown">
                <div
                  class="list-item"
                  :class="{ active: item === timeLimit }"
                  v-for="item in timeList"
                  :key="item"
                  @click="
                    timeLimit = item;
                    timeDropdown = false;
                  "
                >
                  {{ item }}
                </div>
              </div>
            </transition>
          </div>
        </div>
        <div class="col-md-6">
          <p>Maximum allowed events per day for this event</p>
          <input class="form-control" min="0" type="number" value="3" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <h4>Set your weekly hours</h4>
        </div>
        <div class="col-12 days">
          <ul class="unstyled centered">
            <li
              v-for="day in days"
              :key="day"
              @click="activeDay = day.toLowerCase()"
              :class="{
                active: activeDay === day.toLowerCase()
              }"
            >
              <input
                :id="'styled-' + day"
                :checked="isAvailable(day)"
                class="styled-checkbox"
                readonly
                type="checkbox"
              />
              <label>{{ day }} </label>
            </li>
          </ul>
        </div>
        <div class="col-12 available-time-slots">
          <div class="d-flex justify-content-between align-items-center">
            <div class="time-slot">
              <span
                class="selector"
                @click="show.timeSelector = !show.timeSelector"
                >+ Add Time Slot</span
              >
              <TimeSelector
                v-if="show.timeSelector"
                @addSlot="addSlot"
                @closeMe="show.timeSelector = false"
              />
            </div>
            <div>
              <input
                :id="'styled-' + activeDay"
                v-model="slots[activeDay.toLowerCase()].available"
                class="styled-checkbox"
                type="checkbox"
              />
              <label :for="`styled-${activeDay}`">Available </label>
            </div>
          </div>
          <div class="slots" v-if="slots[activeDay]">
            <div v-for="sl in slots[activeDay].slots" :key="sl.id" class="slot">
              <span @click="toggleEdit"
                >{{ formattedTime(sl.startTime) }} -
                {{ formattedTime(sl.endTime) }}</span
              >
              <span class="ico" @click="deleteSlot(sl)"
                ><svg
                  fill="none"
                  height="24"
                  viewBox="0 0 24 24"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    clip-rule="evenodd"
                    d="M2 6C2 5.44772 2.44772 5 3 5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H3C2.44772 7 2 6.55228 2 6Z"
                    fill="#FF8C7D"
                    fill-rule="evenodd"
                  />
                  <path
                    clip-rule="evenodd"
                    d="M10 3C9.73478 3 9.48043 3.10536 9.29289 3.29289C9.10536 3.48043 9 3.73478 9 4V5H15V4C15 3.73478 14.8946 3.48043 14.7071 3.29289C14.5196 3.10536 14.2652 3 14 3H10ZM17 5V4C17 3.20435 16.6839 2.44129 16.1213 1.87868C15.5587 1.31607 14.7956 1 14 1H10C9.20435 1 8.44129 1.31607 7.87868 1.87868C7.31607 2.44129 7 3.20435 7 4V5H5C4.44772 5 4 5.44772 4 6V20C4 20.7957 4.31607 21.5587 4.87868 22.1213C5.44129 22.6839 6.20435 23 7 23H17C17.7957 23 18.5587 22.6839 19.1213 22.1213C19.6839 21.5587 20 20.7957 20 20V6C20 5.44772 19.5523 5 19 5H17ZM6 7V20C6 20.2652 6.10536 20.5196 6.29289 20.7071C6.48043 20.8946 6.73478 21 7 21H17C17.2652 21 17.5196 20.8946 17.7071 20.7071C17.8946 20.5196 18 20.2652 18 20V7H6Z"
                    fill="#FF8C7D"
                    fill-rule="evenodd"
                  />
                  <path
                    clip-rule="evenodd"
                    d="M10 10C10.5523 10 11 10.4477 11 11V17C11 17.5523 10.5523 18 10 18C9.44772 18 9 17.5523 9 17V11C9 10.4477 9.44772 10 10 10Z"
                    fill="#FF8C7D"
                    fill-rule="evenodd"
                  />
                  <path
                    clip-rule="evenodd"
                    d="M14 10C14.5523 10 15 10.4477 15 11V17C15 17.5523 14.5523 18 14 18C13.4477 18 13 17.5523 13 17V11C13 10.4477 13.4477 10 14 10Z"
                    fill="#FF8C7D"
                    fill-rule="evenodd"
                  />
                </svg>
              </span>
              <div class="selector-par">
                <TimeSelector
                  edit
                  @closeMe="closeEdit"
                  @updateSlot="updateSlot"
                  v-if="show.editSelector"
                  :time-slot="sl"
                />
              </div>
            </div>
          </div>
          <button class="btn btn-primary">Update</button>
        </div>
      </div>
      <div
        v-if="show.editSelector || show.timeSelector"
        class="overlay"
        @click="hideEdit"
      ></div>
    </div>
  </div>
</template>
<script>
import TimeSelector from "../../../../../components/timeSelector/index.vue";

export default {
  name: "ListCalendar",
  data() {
    return {
      show: {
        timeSelector: false,
        editSelector: false
      },
      slot: {},
      timeDropdown: false,
      days: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
      timeList: ["15 minutes", "30 minutes", "45 minutes"],
      timeLimit: "15 minutes",
      selectedDays: [],
      activeDay: "sun",
      start: "",
      end: "",
      slots: {
        sun: {
          available: true,
          slots: []
        },
        mon: {
          available: true,
          slots: []
        },
        tue: {
          available: true,
          slots: []
        },
        wed: {
          available: true,
          slots: []
        },
        thu: {
          available: true,
          slots: []
        },
        fri: {
          available: true,
          slots: []
        },
        sat: {
          available: true,
          slots: []
        }
      }
    };
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    TimeSelector
  },
  mounted() {
    this.getSlots();
  },
  methods: {
    hasSlot(day) {
      return this.slots[day.toLowerCase()];
    },
    toggleAvailability(day) {
      let old = this.slots[day.toLowerCase()].available;
      console.log(old);
      this.slots[day.toLowerCase()].available = !old;
      console.log(!old);
    },
    isAvailable(day) {
      return (
        this.slots[day.toLowerCase()] &&
        this.slots[day.toLowerCase()].available &&
        this.slots[day.toLowerCase()].slots.length > 0
      );
    },
    deleteSlot(sl) {
      console.log(sl);
    },
    toggleEdit(ev) {
      this.show.editSelector = true;
      ev.target.closest(".slot").classList.add("active");
    },
    closeEdit() {
      this.show.editSelector = false;
      document.querySelectorAll(".slot").forEach(el => {
        el.classList.remove("active");
      });
    },
    hideEdit() {
      this.show.editSelector = false;
      this.show.timeSelector = false;
      document.querySelectorAll(".slot").forEach(slot => {
        slot.classList.remove("active");
      });
    },
    getSlots() {
      this.$store
        .dispatch("listings/getSlots", this.profile.userId)
        .then(res => {
          console.log("tag", res);
          if (res) {
            console.log("tag", res);
            let slots = res;
            console.log("tag1", slots.mon && slots.mon[0].start);

            for (var prop in slots) {
              console.log("prop new", prop, slots[prop]);
              // for (var day in this.slots[prop]) {
              //   console.log("dayslot", this.slots[prop][day]);
              if (slots && prop != "timings" && prop != "_created_at") {
                slots[prop].forEach(element => {
                  this.revertStart(element.start, element.end, prop);
                  // this.revertStart(element.end, prop);

                  // this.revertEnd(element.end, prop);
                });
                // }
              }

              // res.forEach(element => {
              //   console.log("available times", element);
              //   // element.start_date = element.start_date.toDate();
              //   // element.end_date = element.end_date.toDate();
              //   // this.availableTimes.push(element);
              // });
            }
          }
          this.fetching = false;
        })
        .catch(e => {
          console.log("Error in Fetching Guide Availability.", e);
        });
    },
    getPeriod(hour) {
      return parseInt(hour) < 13
        ? (this.slot.period = "AM")
        : (this.slot.period = "PM");
    },
    revertStart(start_time, end_time, prop) {
      let s_slot = {};
      let e_slot = {};
      let s_hour = start_time.slice(0, 2);
      let s_mins = start_time.slice(2, 4);
      s_slot.period = this.getPeriod(s_hour);
      s_slot.hour = s_slot.period == "PM" ? s_hour - 12 : s_hour;
      s_slot.hour = s_slot.hour == 0 ? 12 : s_slot.hour;
      s_slot.mins = s_mins;
      let e_hour = end_time.slice(0, 2);
      let e_mins = end_time.slice(2, 4);
      e_slot.period = this.getPeriod(e_hour);
      e_slot.hour = e_slot.period == "PM" ? e_hour - 12 : e_hour;
      e_slot.hour = e_slot.hour == 0 ? 12 : e_slot.hour;
      e_slot.mins = e_mins;
      // return { startTime: this.slot };
      console.log("this.slot", { startTime: s_slot, endTime: e_slot });
      this.slots[prop].slots.push({ startTime: s_slot, endTime: e_slot });
    },
    revertEnd(time, prop) {
      let hour = time.slice(0, 2);
      let mins = time.slice(2, 4);
      parseInt(hour) < 13
        ? (this.slot.period = "AM")
        : (this.slot.period = "PM");

      this.slot.hour = hour;
      this.slot.mins = mins;
      // return { endTime: this.slot };
      console.log("this.slot", this.slot, this.slots[prop]);
      this.slots[prop].slots.push({ endTime: this.slot });
    },
    startTime(slot) {
      console.log("in if 1", parseInt(slot.startTime.hour));
      if (
        slot.startTime.period == "AM" &&
        parseInt(slot.startTime.hour) == parseInt(12)
      ) {
        this.start = "00" + slot.startTime.mins;
      }
      if (
        slot.startTime.period == "AM" &&
        parseInt(slot.startTime.hour) < parseInt(12)
      ) {
        console.log("in if 2", parseInt(slot.startTime.hour) > parseInt(12));
        this.start = slot.startTime.hour + slot.startTime.mins;
      }
      if (
        slot.startTime.period == "PM" &&
        parseInt(slot.startTime.hour) != 12
      ) {
        console.log("in if 3", slot);
        this.start = 12 + parseInt(slot.startTime.hour) + slot.startTime.mins;
      }
      if (
        slot.startTime.period == "PM" &&
        parseInt(slot.startTime.hour) == 12
      ) {
        console.log("in if 4", slot);
        this.start = parseInt(slot.startTime.hour) + slot.startTime.mins;
      }
    },
    endTime(slot) {
      if (
        slot.endTime.period == "AM" &&
        parseInt(slot.endTime.hour) == parseInt(12)
      ) {
        this.end = "00" + slot.endTime.mins;
      }
      if (
        slot.endTime.period == "AM" &&
        parseInt(slot.endTime.hour) < parseInt(12)
      ) {
        this.end = slot.endTime.hour + slot.endTime.mins;
      }
      if (slot.endTime.period == "PM") {
        this.end = 12 + parseInt(slot.endTime.hour) + slot.endTime.mins;
      }
      if (slot.endTime.period == "PM" && parseInt(slot.endTime.hour) == 12) {
        console.log("in if 4", slot);
        this.end = parseInt(slot.endTime.hour) + slot.endTime.mins;
      }
    },
    convertStartTime(slot) {
      console.log("in if 1", parseInt(slot.startTime.hour));
      let start = "";
      if (
        slot.startTime.period == "AM" &&
        parseInt(slot.startTime.hour) == parseInt(12)
      ) {
        start = "00" + slot.startTime.mins;
      }
      if (
        slot.startTime.period == "AM" &&
        parseInt(slot.startTime.hour) < parseInt(12)
      ) {
        console.log("in if 2", parseInt(slot.startTime.hour) > parseInt(12));
        start = slot.startTime.hour + slot.startTime.mins;
      }
      if (
        slot.startTime.period == "PM" &&
        parseInt(slot.startTime.hour) != 12
      ) {
        console.log("in if 3", slot);
        start = 12 + parseInt(slot.startTime.hour) + slot.startTime.mins;
      }
      if (
        slot.startTime.period == "PM" &&
        parseInt(slot.startTime.hour) == 12
      ) {
        console.log("in if 4", slot);
        start = parseInt(slot.startTime.hour) + slot.startTime.mins;
      }
      return start;
    },
    convertEndTime(slot) {
      let end = "";
      if (
        slot.endTime.period == "AM" &&
        parseInt(slot.endTime.hour) == parseInt(12)
      ) {
        end = "00" + slot.endTime.mins;
      }
      if (
        slot.endTime.period == "AM" &&
        parseInt(slot.endTime.hour) < parseInt(12)
      ) {
        end = slot.endTime.hour + slot.endTime.mins;
      }
      if (slot.endTime.period == "PM" && parseInt(slot.endTime.hour) != 12) {
        end = 12 + parseInt(slot.endTime.hour) + slot.endTime.mins;
      }
      if (slot.endTime.period == "PM" && parseInt(slot.endTime.hour) == 12) {
        console.log("in if 4", slot);
        end = parseInt(slot.endTime.hour) + slot.endTime.mins;
      }
      return end;
    },
    validTime() {
      console.log("slots => ", this.slots["sun"].slots);
      console.log("valid start => ", this.start);
      console.log("valid end => ", this.end);
      let loopBreak = false;
      let start = this.start;
      let end = this.end;
      for (let i = 0; i < this.slots[this.activeDay].slots.length; i++) {
        let el = this.slots[this.activeDay].slots[i];
        console.log("el ", el);
        let convStartTime = this.convertStartTime(el);
        let convertEndTime = this.convertEndTime(el);
        let slotStart = convStartTime;
        let slotEnd = convertEndTime;
        //console.log("slot valid start => ", start, slotStart);
        //console.log("slot valid end => ", end, slotEnd);
        // if(start == slotStart || (start < (parseInt(slotStart)+15) && end < (parseInt(slotEnd)+15)) || (start > slotStart && end < slotEnd) || end == slotEnd ){
        if (start <= slotEnd && slotStart <= end) {
          //console.log("inside");
          loopBreak = true;
          break;
        }
      }
      if (loopBreak) {
        this.$store.dispatch("user/showNotification", {
          title: "Error Adding Slot",
          description: "Overlaping Time",
          variant: "danger"
        });
        return false;
      }
      console.log("here too", start, " ", end);
      if (start > end || start == end || this.end == 0) {
        console.log("here too in", start, " ", end);

        this.$store.dispatch("user/showNotification", {
          title: "Error Adding Slot",
          description: "Invalid Time For One Day",
          variant: "danger"
        });
        return false;
      }
      return true;
    },
    async addSlot(slot) {
      console.log(slot);
      await this.startTime(slot);
      await this.endTime(slot);
      let validTime = await this.validTime();
      if (!validTime) {
        return false;
      }
      console.log("start", this.start);
      console.log("end", this.end);
      this.mode = "inserted";
      this.show.timeSelector = false;
      // const id = Math.random() * 1000 + Math.random() * 50;
      this.slots[this.activeDay].slots.push({ ...slot });
      let payload = {
        activeDay: this.activeDay,
        guideId: this.profile.userId,
        start: this.start,
        end: this.end,
        mode: this.mode
        // id: id
      };
      console.log("payload => ", payload);
      this.$store
        .dispatch("listings/updateSlot", payload)
        .then(() => {
          // this.getAvailability();
          this.$store.dispatch("user/showNotification", {
            title: "Success",
            description: "Availbility updated successfully.",
            variant: "success"
          });
        })
        .catch(e => {
          this.$store.dispatch("user/showNotification", {
            title: "Error Updating Guide Availability",
            description: e,
            variant: "danger"
          });
        });
      console.log(this.slots[this.activeDay], this.activeDay);
    },
    updateSlot(slot) {
      this.closeEdit();
      let index = this.slots.findIndex(sl => sl.id === slot.id);
      this.slots[index] = slot;
    },
    formattedTime(time) {
      if (time) {
        return time.hour + ":" + time.mins + time.period;
      }
    }
  }
};
</script>
/
<style lang="scss" scoped>
.list-view {
  @media (min-width: 556px) {
    margin-right: 16px;
    // height: calc(100vh - 500px);
    height: auto;

    overflow-y: auto;
    overflow-x: hidden;
  }
  &::-webkit-scrollbar {
    width: 6px;
    margin-right: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: #fff;
  }

  &::-webkit-scrollbar-thumb {
    background: #dddddd;
    border-radius: 16px;
  }

  h4 {
    font-family: "Nunito", sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    color: #474d52;
  }

  p {
    font-family: "Nunito", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    color: #8d99a0;
    margin-bottom: 8px;
  }

  .dropdown-listview {
    width: 163px;
    height: 47px;
    background: #ffffff;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    border-radius: 40px;
    display: flex;
    align-items: center;
    position: relative;
    .dropdown-list {
      position: absolute;
      top: 100%;
      left: 0;
      width: 100%;
      background-color: #fff;
      padding: 12px;
      border-radius: 18px;
      z-index: 1;
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);

      .list-item {
        font-size: 16px;
        cursor: pointer;
        transition: all 0.2s ease-in-out;
        &:hover,
        &.active {
          color: #557efb;
        }
      }
    }
    .dropdown-target {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 24px;
      cursor: pointer;
      width: 100%;
    }

    span {
      font-family: "Nunito", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 22px;
      color: #474d52;
      position: relative;
    }
  }

  .selector-row {
    margin-bottom: 32px;
  }

  .form-control {
    width: 118px;
    height: 47px;
    background: #ffffff;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    border-radius: 40px;
    border: none;
    /* Chrome, Safari, Edge, Opera */
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */
    &[type="number"] {
      -moz-appearance: textfield;
    }
  }

  .days {
    .styled-checkbox {
      position: absolute;
      opacity: 0;

      & + label {
        position: relative;
        cursor: pointer;
        padding: 0;
        user-select: none;
        font-family: "Nunito", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        color: #8d99a0;
      }

      & + label:before {
        content: "";
        margin-right: 10px;
        display: inline-block;
        vertical-align: text-top;
        width: 20px;
        height: 20px;
        background: #dddddd;
        border-radius: 2px;
      }

      &:checked + label:before {
        background: #557efb;
      }

      &:disabled + label {
        color: #b8b8b8;
        cursor: auto;
      }

      &:disabled + label:before {
        box-shadow: none;
        background: #ddd;
      }

      &:checked + label {
        font-weight: bold;
        color: #557efb;
      }

      &:checked + label:after {
        content: "";
        position: absolute;
        left: 5px;
        top: 9px;
        background: white;
        width: 2px;
        height: 2px;
        box-shadow: 2px 0 0 white, 4px 0 0 white, 4px -2px 0 white,
          4px -4px 0 white, 4px -6px 0 white, 4px -8px 0 white;
        transform: rotate(45deg);
      }
    }

    .unstyled {
      margin: 0;
      padding: 0;
      list-style-type: none;
      display: flex;
      box-shadow: 0px 1px 0px #dddddd;

      li {
        width: 120px;
        padding: 12px;

        &.active {
          box-shadow: 0px 2px 0px #557efb;
        }
      }
    }
  }

  .available-time-slots {
    padding: 20px 12px;

    .time-slot {
      position: relative;

      .selector {
        font-family: "Nunito", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        cursor: pointer;
        color: #557efb;
      }
    }
    .styled-checkbox {
      position: absolute;
      opacity: 0;

      & + label {
        position: relative;
        cursor: pointer;
        padding: 0;
        user-select: none;
        font-family: "Nunito", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        color: #8d99a0;
      }

      & + label:before {
        content: "";
        margin-right: 10px;
        display: inline-block;
        vertical-align: text-top;
        width: 20px;
        height: 20px;
        background: #dddddd;
        border-radius: 2px;
      }

      &:checked + label:before {
        background: #557efb;
      }

      &:disabled + label {
        color: #b8b8b8;
        cursor: auto;
      }

      &:disabled + label:before {
        box-shadow: none;
        background: #ddd;
      }

      &:checked + label {
        font-weight: bold;
        color: #557efb;
      }

      &:checked + label:after {
        content: "";
        position: absolute;
        left: 5px;
        top: 9px;
        background: white;
        width: 2px;
        height: 2px;
        box-shadow: 2px 0 0 white, 4px 0 0 white, 4px -2px 0 white,
          4px -4px 0 white, 4px -6px 0 white, 4px -8px 0 white;
        transform: rotate(45deg);
      }
    }
    .slots {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      padding: 16px 0;
      column-gap: 16px;
      row-gap: 16px;
      min-height: 200px;
      border-bottom: 1px solid #dddddd;

      .slot {
        background: #ffffff;
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
        border-radius: 40px;
        position: relative;
        padding-right: 40px;
        span {
          display: inline-block;
          padding: 12px 24px;
          font-family: "Nunito", sans-serif;
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
          line-height: 22px;
          color: #474d52;
          cursor: pointer;
        }
        .ico {
          cursor: pointer;
          position: absolute;
          top: 50%;
          right: 0;
          transform: translateY(-50%);
        }

        .selector-par {
          display: none;
        }

        &.active {
          .selector-par {
            display: block;
          }
        }
      }
    }

    .btn-primary {
      margin-top: 32px;
      border-radius: 34px;
      padding: 12px 56px;

      font-family: "Nunito", sans-serif;
      font-style: normal;
      font-weight: bold;
      font-size: 16px;
      line-height: 22px;
      color: #ffffff;
    }
  }
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 7;
}

@media (max-width: 500px) {
  .unstyled {
    width: 70vw;
    overflow-x: auto;

    &::-webkit-scrollbar {
      height: 6px;
      margin-top: 10px;
    }

    &::-webkit-scrollbar-track {
      background-color: #fff;
    }

    &::-webkit-scrollbar-thumb {
      background: #dddddd;
      border-radius: 16px;
    }
  }
  .list-view .available-time-slots .slots {
    justify-content: center;
  }
}
</style>
